import React, {useEffect, useState} from 'react';
import {Template} from "../../../../../components/template/template.jsx";
import {Card} from "../../../../../components/card/card.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import {useParams} from "react-router";
import projectUtils from "../../../../../utils/project-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import materialGroupService from "../../../../../services/web/material-group-service.js";
import {FaPlus} from "react-icons/fa";
import Alert from "../../../../../components/alert/alert.jsx";

const initialData = {
    id: "", description: "",
}

const MaterialGroupForm = () => {
    const navigate = navigateHook();
    const {id} = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState(initialData)
    const [canRemove, setCanRemove] = useState(false)

    const onChange = ({target: {value, id}}) => setData(prev => ({...prev, [id]: value}))

    const {data: materialGroup, refetch, status} = useQuery({
        queryKey: ['material-group'], queryFn: () => materialGroupService.getById(id), enabled: !!id
    });

    useEffect(() => {
        if (status === "success") {
            const materialNormalized = projectUtils.normalizeData(materialGroup.group)
            setCanRemove(materialGroup.storages || materialGroup.materials)
            setData(materialNormalized)
        }
    }, [materialGroup, status]);

    const saveAdd = () => save(true)

    const save = (saveAdd) => {
        setIsLoading(true);

        const formData = new FormData()
        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
        });

        materialGroupService.save(formData, id)
            .then(({data}) => {
                projectUtils.success(!id || saveAdd);

                if (saveAdd) {
                    setData(initialData)
                    navigate("/materials/groups/form");
                    return;
                }

                if (id) {
                    refetch()
                    return;
                }

                const urlDev = `/materials/groups/form/${data.id}`;
                navigate(urlDev);
            })
            .catch((error) => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = error.response.data.message;
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
            .finally(() => setIsLoading(false))
    }

    const remove = async () => {
        projectUtils.swalMessage('warning', 'Excluir', `Excluir o grupo "${data.description}"?`, 'Sim', true, 'Não',
            ({isConfirmed}) => {
                if (!isConfirmed) return

                materialGroupService.delete(id)
                    .then(() => {
                        projectUtils.success(true, "Excluído com sucesso")
                        navigate("/materials/groups")
                    })
                    .catch(error => {
                        console.error(error);
                        let message = 'Não foi possível excluir.';
                        if (error.response.status !== 500) {
                            message = error.response.data.message;
                        }

                        projectUtils.swalErrorMessage('', message, 'Ok');
                    });
        });
    }

    const openForm = () => {
        const url = `/materials/groups/form`;
        navigate(url)
    }

    return (<Template isLoading={isLoading}>
        <Template.Header>
            <Template.Title>
                Grupo de materiais
            </Template.Title>
            {
                id &&
                <Button target={"primary-outline"} onClick={openForm}>
                    <FaPlus/><span className="font-bold">Adicionar grupo</span>
                </Button>
            }
        </Template.Header>
        <Template.Body>
            <Card className={"mb-2"}>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12">
                            <InputForm
                                id="description"
                                name={"description"}
                                value={data.description}
                                label="Descrição *"
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </Card.Body>
            </Card>
            <Card>
                <Card.Body>
                <div className="flex justify-end gap-2 w-full items-center">
                    {!id && <Button target={"primary-outline"} onClick={saveAdd} actionFeedbackType='save'>Salvar e adicionar novo</Button>}
                    {canRemove && <Alert className={"p-[5px_10px]!"} target="warning">Não é possível excluir, pois existem associações dependentes do grupo.</Alert>}
                    {
                        id &&
                        <Button disabled={canRemove} target={"danger"} onClick={remove} actionFeedbackType='delete'>Excluir</Button>
                    }
                    <Button onClick={() => save(false)} actionFeedbackType='save'>Salvar</Button>
                </div>
                </Card.Body>
            </Card>
        </Template.Body>
    </Template>);
};

export default MaterialGroupForm;